export default __webpack_public_path__ + "static/de-b29e42e186ff8f796822742b53b3001d.svg";